import React, {Component, Fragment, useEffect, useState} from 'react'
import Counter from "../components/counter";
import ProgressBar from "@ramonak/react-progress-bar";
import DonationButton from "../components/donation-button";
import RenderConfetti from "../components/confetti";
import {ASSET_URL} from "../../../config";
import {getDeviseSymbol} from "../../../i18n";
import {getPrimaryColor} from "../tokens";
import {Trans} from "@lingui/react/macro";

export default function Bar({context,campagneData,campagneTarget}){

    const isMobile=context.isMobile
    const org=context.org
    const total=campagneData.stats.total.sum.total
    const totalNb=campagneData.stats.total.count.total

    const [counterTime, setCounterTime] = useState("")

    useEffect(()=>{
        const interval=setInterval(()=>{
            const timeRemaining=calculTimeRemaining()
            setCounterTime(timeRemaining)
        },500)

        return()=>{
            clearInterval(interval)
        }
    },[])


    let bonus=null
    let _objectif=campagneData.objectif
    if(_objectif<total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length>0){
        bonus=campagneData.bonus.find(b=>b>total)
        if(!bonus){
            bonus=campagneData.bonus.at(-1)
        }
    }
    if(bonus){
        _objectif=bonus
    }

    const percent=(_objectif>0 ? (total/_objectif)*100 : 0)
    const displayPercent=(Number(campagneData.objectif)>0 ? (total/campagneData.objectif)*100 : 0)

    let progressColor=getPrimaryColor(campagneData.config)

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })


    let showCounter=false
    if(new Date()>=new Date(campagneData.dateStart) && new Date()<=new Date(campagneData.dateEnd)){
        showCounter=true
    }

    const calculTimeRemaining=() => {
        const currentTime = new Date();

        const timeRemaining = new Date(campagneData.dateEnd).getTime() - currentTime.getTime();

        let seconds = Math.floor(timeRemaining / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let days = Math.floor(hours / 24);

        seconds %= 60;
        minutes %= 60;
        hours %= 24;

        return days+"j "+("0"+hours.toString()).slice(-2)+"h "+("0"+minutes.toString()).slice(-2)+"m "+("0"+seconds.toString()).slice(-2)+"s"
    }


    if(isMobile)
    {
        return(
            <Fragment>

                <div style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    marginTop: 30,
                    padding: 0,
                    color: "#373737"
                }}>

                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "15px",
                        borderBottom: "1px solid " + progressColor,
                        textAlign: "center",
                        width: "80vw"
                    }}>
                        <img src={campagneData?.config["ald.logo"]?ASSET_URL+"/"+campagneData.config["ald.logo"]:org.logo} style={{height: 100, width: 100}}/>
                        <div style={{fontSize: 20, fontWeight: "bold", marginTop: 20}}>{campagneData?.config["ald.name"] || org.name}</div>
                    </div>

                    <h4 style={{
                        textAlign: "center",
                        marginTop: "2rem",
                        fontSize: 24,
                        fontWeight: "bold"
                    }}>{campagneData.name}</h4>

                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "15px 0px",
                        borderBottom: "1px solid " + progressColor,
                        width: "80vw"
                    }}>


                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: 30,
                            textAlign: "center",
                            width: "80vw"
                        }}>
                            <div style={{fontSize: "3rem", fontWeight: "bold", color: progressColor}}>
                                <Counter number={total} decimals={0}/>{getDeviseSymbol(context)}
                            </div>
                            <div style={{fontSize: 16, fontWeight: "bold"}}><Trans>Montant collecté</Trans></div>

                        </div>

                        {!bonus && (
                            <span style={{
                                fontSize: 16,
                                fontWeight: 700,
                                marginLeft: 10
                            }}>
                        <Trans>Objectif : {formater.format(campagneData.objectif)}{getDeviseSymbol(context)}</Trans>
                    </span>
                        )}

                        {bonus && (
                            <Fragment>
                            <span style={{
                                fontSize: 16,
                                fontWeight: 700,
                                marginLeft: 10,
                                textDecorationLine: "line-through"
                            }}><Trans>Objectif : {formater.format(campagneData.objectif)}{getDeviseSymbol(context)}</Trans></span>

                                <span style={{
                                    color: "#5cb85c",
                                    fontSize: 16,
                                    fontWeight: 700,
                                    marginLeft: 10,
                                }}><Trans>Nouvelle Objectif : {formater.format(_objectif)}{getDeviseSymbol(context)}</Trans></span>
                            </Fragment>
                        )}

                        <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 10,marginBottom:20}}>
                            <ProgressBar
                                customLabel={" "}
                                animateOnRender
                                completed={percent >= 10 ? percent : 10}
                                width={"65vw"}
                                height={"10px"}
                                bgColor={progressColor}
                                baseBgColor={progressColor + "20"}
                            />

                            <span style={{fontSize: 16, fontWeight: 700, marginLeft: 10}}>
                                <Counter number={displayPercent >= 1 ? Math.floor(displayPercent) : displayPercent} decimals={displayPercent >= 1 ? 0 : 1}/>%
                            </span>
                        </div>


                        {showCounter && (
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "0px 15px",
                                textAlign: "center",
                                minWidth: "80vw"
                            }}>
                                <div style={{fontSize: 24, fontWeight: "bold"}}>{counterTime}</div>
                                <div style={{fontSize: 16, fontWeight: "bold"}}><Trans>Temps restant</Trans></div>
                            </div>
                        )}

                    </div>

                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "15px 0px",
                        paddingBottom: 30,
                        textAlign: "center",
                        width: "80vw"
                    }}>


                        <div style={{fontSize: "3rem", fontWeight: "bold", color: progressColor}}>
                            <Counter number={totalNb} decimals={0}/>
                        </div>
                        <div style={{fontSize: 16, fontWeight: "bold"}}><Trans>Donateurs</Trans></div>

                    </div>

                    {(percent>=100) &&(
                        <RenderConfetti/>
                    )}
                </div>
            </Fragment>
        )
    }


    return (
        <Fragment>

            <h4 style={{
                textAlign: "center",
                marginTop: "3rem",
                marginBottom: "3rem",
                fontSize: 24,
                fontWeight: "bold"
            }}>{campagneData.name}</h4>

            <div style={{
                width: "100%",
                display: "flex",
                flexWrap:"wrap",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 0",
                gap:20,
                color: "#373737"
            }}>

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "15px 20px",
                    borderRadius:20,
                    border: "1px solid " + progressColor
                }}>

                    {!bonus && (
                        <span style={{
                            fontSize: 16,
                            fontWeight: 700,
                            marginLeft: 10
                        }}>
                        <Trans>Objectif : {formater.format(campagneData.objectif)}{getDeviseSymbol(context)}</Trans>
                    </span>
                    )}

                    {bonus && (
                        <Fragment>
                            <span style={{
                                fontSize: 16,
                                fontWeight: 700,
                                marginLeft: 10,
                                textDecorationLine: "line-through"
                            }}><Trans>Objectif : {formater.format(campagneData.objectif)}{getDeviseSymbol(context)}</Trans></span>

                            <span style={{
                                color: "#5cb85c",
                                fontSize: 16,
                                fontWeight: 700,
                                marginLeft: 10,
                            }}><Trans>Nouvelle Objectif : {formater.format(_objectif)}{getDeviseSymbol(context)}</Trans></span>
                        </Fragment>
                    )}

                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20}}>
                        <ProgressBar
                            customLabel={" "}
                            animateOnRender
                            completed={percent >= 10 ? percent : 10}
                            width={"18vw"}
                            height={"10px"}
                            bgColor={progressColor}
                            baseBgColor={progressColor + "20"}
                        />

                        <span style={{fontSize: 16, fontWeight: 700, marginLeft: 10}}>
                        <Counter number={displayPercent >= 1 ? Math.floor(displayPercent) : displayPercent} decimals={displayPercent >= 1 ? 0 : 1}/>%
                    </span>
                    </div>
                </div>


                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "15px 15px",
                    borderRadius:20,
                    border: "1px solid " + progressColor,
                    textAlign: "center",
                    minWidth: "20%"
                }}>


                    <div style={{fontSize: 35, fontWeight: "bold", color: progressColor}}>
                        <Counter number={total} decimals={0}/>{getDeviseSymbol(context)}
                    </div>
                    <div style={{fontSize: 16, fontWeight: "bold"}}><Trans>Montant collecté</Trans></div>

                </div>

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "15px 15px",
                    borderRadius:20,
                    border: "1px solid " + progressColor,
                    textAlign: "center",
                    minWidth: "20%"
                }}>


                    <div style={{fontSize: 35, fontWeight: "bold", color: progressColor}}>
                        <Counter number={totalNb} decimals={0}/>
                    </div>
                    <div style={{fontSize: 16, fontWeight: "bold"}}><Trans>Donateurs</Trans></div>

                </div>


                {showCounter && (
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "25px 15px",
                        borderRadius:20,
                        border: "1px solid " + progressColor,
                        textAlign: "center",
                        minWidth: "20%"
                    }}>


                        <div style={{fontSize: 24, fontWeight: "bold"}}>{counterTime}</div>
                        <div style={{fontSize: 16, fontWeight: "bold"}}><Trans>Temps restant</Trans></div>

                    </div>
                )}


                {(percent>=100) &&(
                    <RenderConfetti/>
                )}
            </div>
        </Fragment>
    )
}
